const tryParseJson = (value) => {
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const decodeHexEscapedString = (value) =>
  value.replace(/\\x([0-9a-fA-F]{2})/g, (_, hex) =>
    String.fromCharCode(parseInt(hex, 16))
  );

/**
 * IAM policy documents may arrive as objects, raw JSON strings, URL-encoded JSON,
 * or legacy hex-escaped byte strings depending on sync/storage history.
 */
export const parseAwsPolicyDocument = (policyDocument) => {
  if (policyDocument == null) {
    return null;
  }

  if (typeof policyDocument === "object") {
    return policyDocument;
  }

  if (typeof policyDocument !== "string") {
    return null;
  }

  const raw = policyDocument.trim();
  if (!raw) {
    return null;
  }

  let parsed = tryParseJson(raw);
  if (parsed) {
    return parsed;
  }

  try {
    const urlDecoded = decodeURIComponent(raw.replace(/\+/g, " "));
    parsed = tryParseJson(urlDecoded);
    if (parsed) {
      return parsed;
    }
  } catch {
    // ignore decode errors
  }

  if (/^\\x[0-9a-fA-F]{2}/.test(raw)) {
    parsed = tryParseJson(decodeHexEscapedString(raw));
    if (parsed) {
      return parsed;
    }
  }

  return null;
};

export const getAwsPolicyStatements = (policyDocument) => {
  const parsed = parseAwsPolicyDocument(policyDocument);
  if (!parsed?.Statement) {
    return [];
  }
  return Array.isArray(parsed.Statement) ? parsed.Statement : [parsed.Statement];
};
